console.log('noew try ')

jQuery(function($) {

    $(document).on("click", ".logo-popup__close" , function() {
        $('.modal--logo-popup').attr("aria-hidden","true");
          if(window.location.href.includes("/cart")){
            window.location.reload();
          }
    });

    $(document).on("click", ".continue-logo-preview" , function() {
        $('.modal--logo-popup').attr("aria-hidden","true");
          if(window.location.href.includes("/cart")){
            window.location.reload();
          }
    });
  
  if($('.custom-qty').length > 0){
    $('.custom-qty').each(function(){
      var thelabel = $(this).find('label')
	   if(thelabel.text().toLowerCase() == '1 size'){
         thelabel.text('Qty')
       }
    })
  }
	
  	var zoomSlider = '';
  
  	function destroyZoomImages(){
      	$('#product-zoom-contents').empty();
 	}
  
  
  	function setupZoomImages(state){
      	var img_block = ''; 
             
      	$('#main-gallery img').each(function(){
          	var img = $(this).attr('src')
            if(img.includes('cloudinary')){
            }
            // else if($(this).attr('alt').includes('no-logo')){
            // }
          	else{
            	var img = $(this).attr('data-zoom')
            }
          
            img_block += '<div class="img-container"><img src="'+ img +'" /></div>';
	    })
        
        $('#product-zoom-contents').append(img_block)

        // zoomSlider = $('#product-zoom-contents').flickity({
        //   "lazyLoad": 2,
        //   "imagesLoaded": true,
        //   "draggable": true,
        //   "prevNextButtons": true,
        //   "wrapAround": true,
        //   "cellAlign": 'center',
        //   "pageDots": false,
        //   "contain": true,
        //   "freeScroll": true,
        //   "initialIndex": 1
        // });
    }	
  
  	var logoMover =  '<div class="logo-mover"><button class="up">&uarr;</button><button class="right">&rarr;</button><button class="down">&darr;</button><button class="left">&larr;</button> <p class="small-mover-text">Adjust Logo</p></div>'
  
    var logoMoverPlaced = true;	
    
    var selectedShirt;
    var selectedShirtImg;

    //Configure & Init Cloudinary
    var loadedLogo = {
        original_size: {
            height: "auto",
            width: "auto"
        },
        transformed_size: {
            height: 0,
            width: 0,
            base_width: 0,
            scale: 1
        },
        url: undefined,
        secure_url: undefined,
        scalable_image_url: undefined,
        public_id: undefined,
        original_filename: undefined,
        desktop_product_url: undefined,
        desktop_zoom_product_url: undefined,
        composition_url_desktop: undefined,
        composition_url_desktop_zoom: undefined,
        img_real_width: undefined,
        img_real_height: undefined,
        proof_number: undefined
    };

    var setLogoData = function(data) {
        for (var key in data) {
            if (loadedLogo.hasOwnProperty(key) && data.hasOwnProperty(key)) {
                loadedLogo[key] = data[key];
            }
        }
        return loadedLogo;
    };


    var cloudinaryConfig = {
        api_key: "542581144251298",
        api_secret: "_dzfisrJh4bhVYzJ5L9EczPGZjc",
        cloud_name: "threadlogic-com",
        upload_preset: "esfwmkjo",
        secure: true
    };

    $.cloudinary.config(cloudinaryConfig);

    var formData = {
        upload_preset: cloudinaryConfig.upload_preset
    };

    $("input.cloudinary-fileupload[type=file]").attr('data-form-data', JSON.stringify(formData));

    //Configure & Init Cloudinary




    //Process Logos & Shirts

  	function insertLogoMover(){
		//product_gallery
      	if(!logoMoverPlaced){
          	setTimeout(function(){
            	$('.product-gallery__carousel-wrapper').append(logoMover)	
	            logoMoverPlaced = true;
            })      	
        }
  	}
	
  	function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  
    function createLogoOverlay(productImgUrl, logoCloudinaryId, position) {
        
        console.log(productImgUrl)
      console.log(logoCloudinaryId);
      console.log("_logoPositionX", _logoPositionX);
      console.log("_logoPositionY", _logoPositionY);
      console.log("_logoMaxWidth", _logoMaxWidth);
      console.log("_logoMaxHeight", _logoMaxHeight);

        if (loadedLogo.img_real_width == undefined || loadedLogo.img_real_height == undefined) {
            console.log('Image real width or height is not defined. Cannot generate the image composition');
            return;
        }
      	
      	var logoYposition = 120;
		var logo_offset_val = $("#logo_offset_value").val().toLowerCase();
        
      	if(logo_offset_val == 'big_hood_offset'){
        	logoYposition = 250;
        }
      	else if(logo_offset_val == 'small_hood_offset'){
            logoYposition = 200;
        }
            else if(logo_offset_val == 'quarter_zip_offset'){
            logoYposition = 150;
        }
      	else{
          if(isNumber(logo_offset_val)){
            console.log(logo_offset_val)
            logoYposition  = logo_offset_val
          }
        }
      
      	var logoXposition = 140;
        if(position == 'left'){
        	logoXposition = 140
        }
        if(position == 'right'){
        	logoXposition = 290
        }
      
        var realW = loadedLogo.img_real_width;
        var realH = loadedLogo.img_real_height;
        var logoRealW = loadedLogo.original_size.width;
        var logoRealH = loadedLogo.original_size.height;
        var logoW = parseInt((240 / 100) * realW);

        var scale = loadedLogo.transformed_size.scale;
        if (logoRealW > logoRealH) {
            imgW = Math.round(logoW * scale)
            var auxScale = imgW / logoRealW;
            imgH = Math.round(logoRealH * auxScale);
        } else {
            imgH = Math.round(logoW * scale);
            var auxScale = imgH / logoRealH;
            imgW = Math.round(logoRealW * auxScale);
        }

        var hardWidth = 70;
        var hardHeight = 40;
        
        var gravity = 'north_east'

        if(position == 'center'){

            gravity = 'center';
            hardWidth = 600;
            hardHeight = 300;
            logoXposition = 0
            logoYposition = -60

            if(logo_offset_val == 'small_hat_offset'){
                logoYposition = 0
                hardWidth = 250;
                hardHeight = 125;
            }
            else if(logo_offset_val == 'beanie_offset'){ 
                logoYposition = 350
                hardWidth = 540;
                hardHeight = 270;
                // gravity = 'south';
            }
            else if(logo_offset_val == 'small_beanie_offset'){ 
                logoYposition = 100
                hardWidth = 270;
                hardHeight = 100;
                // gravity = 'south';
            }

        }

        // Convert percentage values
        var x = 40;
        var y = 40;
        if (imgW < logoW) {
            x += Math.round((logoW - imgW) / 2);
        }
        if (imgH < logoW) {
            y += Math.round((logoW - imgH) / 2);
        }
        if (productImgUrl && productImgUrl.trim() !== '' && logoCloudinaryId && logoCloudinaryId.trim() !== '') {
            var url = $.cloudinary.image(productImgUrl, {
                transformation: [{
                    width: (_logoMaxWidth >= 0) ? _logoMaxWidth : hardWidth,
                    height: (_logoMaxHeight >= 0) ? _logoMaxHeight : hardHeight,
                    crop: 'fit',
                    gravity: 'center',
                    overlay: new cloudinary.Layer().publicId(logoCloudinaryId),
                    effect: 'make_transparent:30',
                    },
                                 {
                    width: (_logoMaxWidth >= 0) ? _logoMaxWidth : hardWidth,
                    height: (_logoMaxHeight >= 0) ? _logoMaxHeight : hardHeight,
                    crop: 'pad',
                    gravity: 'center',
                    format: 'png'},
                                 {flags: "layer_apply", 
                                  gravity: _logoGravity ? _logoGravity : gravity,
                    x: (_logoPositionX > -1000) ? _logoPositionX : logoXposition,
                    y: (_logoPositionY > -1000) ? _logoPositionY : logoYposition
                }],
                type: "fetch"
            });

            var url_src = url.attr('src');

            //console.log(url_src)

            return url_src;
        }
        return false;
    };

  

    function saveToStorage(key, logo) {
        localStorage.setItem(key, logo);
    }

    function getFromStorage(key) {
        return localStorage.getItem(key);
    }

    function setLogoDataFromSession(logoUrl, img_real_width, img_real_height, current_image_url) {

        var secure_url = getFromStorage('logo_secure_url')
        var scalable_url = getFromStorage('logo_scalable_image')
        var public_id = getFromStorage('logo_id')
        var original_filename = getFromStorage('logo_original_filename')
	
        $('.logo-filename').text('Your Logo: ');
        $('#custom_logo_url').html('<img src="'+scalable_url+'" alt="Logo" width=50 height=50 />');
        $('.existing-logo').addClass('active');
        $('.logo-upload span').text('Change Logo');
        $('.no-logo-panel').addClass('hide');
        $('.cart-logo-wrapper').html('<a target="_blank" style="text-decoration:underline;" href="'+secure_url+'" rel="noopener" aria-describedby="a11y-new-window-message"><img id="order_logo_img" src="'+secure_url+'" style="margin: 10px auto 30px auto; width:auto;display:block;"></a>'+
'    <button type="button" class="cart-recap__note-button" data-action="toggle-collapsible" data-collapsible-force-overflow="" aria-controls="order-note" aria-expanded="true">Order Notes<span>'+
'            <span class="cart-recap__note-edit ">Edit</span><svg focusable="false" class="icon icon--arrow-bottom " viewBox="0 0 12 8" role="presentation">'+
'      <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>'+
'    </svg></span>'+
'    </button>'+
'    <div id="order-note" aria-hidden="false">'+
'        <div class="cart-recap__note-inner">'+
'            <textarea id="noteTextarea" name="note" class="form__field form__field--textarea" rows="3">'+mwProductFeesObjects?.cart?.note+'</textarea>'+
'            <button id="saveButton" type="button" class="form__submit form__submit--tight button button--secondary" data-action="save-note">Save</button>'+
'        </div>'+
'    </div>');
        ////$('.cloudinary-fileupload').hide();
        
        setLogoData({
            original_size: {
                height: 80,
                width: 80
            },
            url: logoUrl,
            secure_url: secure_url,
            scalable_image_url: scalable_url,
            public_id: public_id,
            original_filename: original_filename,
            img_real_width: img_real_width,
            img_real_height: img_real_height,
        });


            fetch("/cart/update.js", {
              body: JSON.stringify({
                attributes: {
                  'order_logo': secure_url
                }
              }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    
              }
            });
      
    }

    function updateLogoData(logoUrl, selectedShirtImg) {

        var img_real_width = $(selectedShirtImg).width()

        var img_real_height = $(selectedShirtImg).height()
        // var current_image_url = 'https:' + $('.product-gallery__carousel-item.is-selected img').attr('data-zoom')
        var current_image_url = 'https:' + $('.product-gallery__carousel-item.is-selected img').attr('data-logo-img')

        setLogoDataFromSession(logoUrl, img_real_width, img_real_height, current_image_url)

    }

    function updateProductImage() {
        
      	var logoId = getFromStorage('logo_id')

        if (logoId === null) {
            console.log('null')
            return;
        }

        setTimeout(function() {
            //Selected Shirt
          	
            $('.product-gallery__carousel-item.is-selected img')

            var position = 'left';
            if($(selectedShirtImg) && $(selectedShirtImg).attr('alt').includes('logo-right')){
          		position = 'right'    
            }

            if($('#logo-hat-product').val() == 1){
                position = 'center';
            }
          
            var shirt_src = 'https:' + $(selectedShirtImg).attr('src')

            if (shirt_src.includes('cloudinary')) {
                return;
            }

            var new_logo_img_url = createLogoOverlay(shirt_src, logoId, position)


            $(selectedShirtImg).parent().empty().append("<img data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + new_logo_img_url + "' class='appear lazyautosizes lazyloaded' />");


        }, 250)

    }
  
  	function resetAllProductImages() {
        
        var kk = 0;

        $('.product_gallery .flickity-slider .gallery-cell').each(function() {

          	selectedShirtImg = $(this).find('.image__container img')
            var shirt_src = 'https:' + $(selectedShirtImg).attr('data-zoom')          
			                    
            $(selectedShirtImg).parent().empty().append("<img alt='"+ $(selectedShirtImg).attr('alt') + "' data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + $(selectedShirtImg).attr('data-zoom') + "' class='appear lazyautosizes lazyloaded' />")			
            
        })
        
        if($('.no-custom-logo').length > 0){
        }
      	else{
          setupZoomImages(1)
	        insertLogoMover()
      	}
        

    }

    function updateAllProductImages() {
        var logoId = getFromStorage('logo_id')

        if (logoId === null) {
            console.log('null')
            return;
        }
      

        var logo_url = getFromStorage('logo_url')

        var kk = 0;
updateLogoData(logo_url, '');
        // $('.product_gallery .flickity-slider .gallery-cell').each(function() {
        $(document).find('.product-gallery__carousel .flickity-slider .product-gallery__carousel-item').each(function() {

          	selectedShirtImg = $(this).find('img')
            // var shirt_src = 'https:' + $(selectedShirtImg).attr('data-zoom')    
            var shirt_src = 'https:' + $(selectedShirtImg).attr('data-logo-img')    
            
			
            
         	if($('.no-custom-logo').length > 0){
                updateLogoData(logo_url, selectedShirtImg)
                return;
            }
            
            var position = 'left';            

            if($(selectedShirtImg).attr('alt') && $(selectedShirtImg).attr('alt').includes('logo-right')){
          		position = 'right'    
            }

            if($('#logo-hat-product').val() == 1){
                position = 'center';
            }

            if (shirt_src.includes('cloudinary') || $(selectedShirtImg).attr('alt').includes('no-logo')) {
                $(selectedShirtImg).addClass("dont-change")
                return                
            }
            else{
                updateLogoData(logo_url, selectedShirtImg)
                        
                var new_logo_img_url = createLogoOverlay(shirt_src, logoId, position)

                $(selectedShirtImg).parent().empty().append("<img alt='"+ $(selectedShirtImg).attr('alt') + "' data-logo-img='"+$(selectedShirtImg).attr('data-logo-img')+"' data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + new_logo_img_url + "' class='appear lazyautosizes lazyloaded' />")                
            }

            
			
            
        })
        
        if($('.no-custom-logo').length > 0){
        }
      	else{
          setupZoomImages(1)
	       insertLogoMover()
      	}
        

    }

    function checkStorageData() {
// 	    if($('.no-custom-logo').length > 0){
//           return;
//         }
      
        if (getFromStorage('logo_id')) {

            setTimeout(function() {
                updateAllProductImages()
                if($('.no-custom-logo').length > 0){

                }
	              else{

        	      	//$('.logo-upload-message').addClass('active')
    	          }
            }, 300)
        }
        else{
        	setupZoomImages(0)
        }
    }
    //Process Logos & Shirts


    //Onload Functions
    checkStorageData()

    //Onload Functions


    //Change Events For Inputs 
    $('.upload-toggle').on('change', function() {
        if ($(this).hasClass('upload-show')) {
            $('.logo-upload').addClass('active')
        } else if ($(this).hasClass('upload-hide')) {
            $('.logo-upload').removeClass('active')
        } else {
            $('.logo-upload').removeClass('active')
        }
    })

    var maxFileSize = 5000000;

    if ($.fn.cloudinary_fileupload !== undefined) {
        
        $("input.cloudinary-fileupload[type=file]").cloudinary_fileupload({
            autoUpload: true,
            replaceFileInput: true,
            maxFileSize: maxFileSize,
            loadImageMaxFileSize: maxFileSize,
            acceptFileTypes: /(\.|\/)(gif|jpe?g|png|pdf|ai|eps|psd)$/i
        });

        $('.cloudinary-fileupload').bind('fileuploadsend', function(e, data) {
            console.log('file sending')
        })

        $('.cloudinary-fileupload').bind('fileuploadadd', function(e, data) {
            if (data.files[0].size < maxFileSize) {
                data.submit();
            } else {
                alert('sorry your file is too large')
            }
        })

        $('.cloudinary-fileupload').bind('cloudinarydone', function(e, data) {

            var result = data.result
            var index = result.secure_url.lastIndexOf(".")

            var logo_url = result.url
            var logo_path = result.path
            var logo_etag = result.etag
            var logo_pub_id = result.public_id
            var scalable_image_url = result.secure_url.substring(0, index + 1) + 'png';

            // 		var current_image = $('.gallery-cell.is-selected .image__container img')      
            selectedShirtImg = $('.product-gallery__carousel-item.is-selected img')
            
            var position = 'left';

            if($(selectedShirtImg).length && $(selectedShirtImg).attr('alt').includes('logo-right')){
          		position = 'right';  
            }
                
            if($('#logo-hat-product').val() == 1){
                position = 'center';
            }

            // var selectedShirtImgUrl = 'https:' + $(selectedShirtImg).attr('data-zoom')
            var selectedShirtImgUrl = 'https:' + $(selectedShirtImg).attr('data-logo-img')
                             
            saveToStorage('logo_id', logo_pub_id)
            saveToStorage('logo_url', logo_url)
            saveToStorage('logo_original_filename', result.original_filename)
            saveToStorage('logo_scalable_image', scalable_image_url)
            saveToStorage('logo_secure_url', result.secure_url)
            saveToStorage('logo_on_file', '')
            localStorage.removeItem('logo_on_file');
            $('.logo-on-file').removeClass("selected");
            $('.no-logo-panel').addClass('hide');

            updateLogoData(logo_url, selectedShirtImg)
            
            if($('.no-custom-logo').val() == 1 || $('.no-custom-logo').val() == 1){
				console.log('stop')
                return;
            }

            var new_logo_img_url = createLogoOverlay(selectedShirtImgUrl, getFromStorage('logo_id'), position);

            // $(selectedShirtImg).parent().empty().append("<img alt='"+ $(selectedShirtImg).attr('alt') + "' data-zoom='"+ $(selectedShirtImg).attr('data-zoom') +"' src='" + new_logo_img_url + "' class='appear lazyautosizes lazyloaded' />")

            console.log('why still?')
			updateAllProductImages()
            destroyZoomImages()
            setupZoomImages()
            $('.logo-upload-message').addClass('active');
            
            $('.logo-preview img').attr("src", logo_url);
            $('.modal--logo-popup').attr("aria-hidden","false");


            fetch("/cart/update.js", {
              body: JSON.stringify({
                attributes: {
                  'order_logo': result.secure_url
                }
              }),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    
              }
            });
          if(window.location.href.includes("/cart")){
            $('.cart-item-order-logo').html('<img src="'+logo_url+'" alt="Logo" width="50" height="50" />');
            /////window.location.reload();
          }
          
        });

        //Change Events

    }

  
    function update_url_x_axis(dir){
      	var img_ = $('.product-gallery__carousel-item.is-selected img')
        if($(img_).attr('alt').includes('no-logo')){
         	return
       	}
      	var img_src = $(img_).attr('src')
      	var img_arr = img_src.split('x_')
      
      	var url_start = img_arr[0]
      	var url_end_split = img_arr[1].split(',')
        
        if(url_end_split[0] == ''){
          url_end_split[0] = 0;
        }
      	var cur_url_position = parseFloat(url_end_split[0])
       	
        console.log(dir)
        console.log(cur_url_position)
        var url_new_x_position;
        
        if(dir == 'left'){
            if($('#logo-hat-product').val() == 1){
              url_new_x_position = (cur_url_position - 10)
            }
          	else{
              url_new_x_position = (cur_url_position + 10)
            }
            
            //if(url_new_x_position > 180){ url_new_x_position = cur_url_position }
        }
        else if(dir == 'right'){
          
            if($('#logo-hat-product').val() == 1){
              url_new_x_position = (cur_url_position + 10)
            }
          	else{
              url_new_x_position = (cur_url_position - 10)
            }
           
           //if(url_new_x_position < 100){ url_new_x_position = cur_url_position }
        }
      
      	console.log(url_new_x_position)
      
      	var url_end = url_end_split[1]
      
      	var new_url = url_start + 'x_' + url_new_x_position + ',' + url_end
          
		$('.product-gallery__carousel-item.is-selected img').attr('src', new_url)      

    }
  
  	function update_url_y_axis(dir){
		
       var img_ = $('.product-gallery__carousel-item.is-selected img')

       if($(img_).attr('alt').includes('no-logo')){
         return
       }
      	
      	var img_src = $(img_).attr('src')
      	var img_arr = img_src.split('y_')
        
          
      	var url_start = img_arr[0]
      	var url_end_split = img_arr[1].split('0/')
               
        if(url_end_split[0] == ''){
          url_end_split[0] = 0;
        }
      	
		url_end_split[0] = parseFloat(url_end_split[0]) * 10
      
        var cur_url_position = parseFloat(url_end_split[0])
      
        if(dir == 'up'){                	
            var url_new_y_position = (cur_url_position - 10)
//             if(url_new_y_position < 100){ url_new_y_position = cur_url_position }
        }
        else if(dir == 'down'){
           var url_new_y_position = (cur_url_position + 10)
//            if(url_new_y_position > 160){ url_new_y_position = cur_url_position }
        }
      
      	var url_end = url_end_split[1]
      
      	var new_url = url_start + 'y_' + url_new_y_position + '/' + url_end       
          
		$('.product-gallery__carousel-item.is-selected img').attr('src', new_url)       
      
    }
  
	
  	$('body').on('click', '.logo-mover button', function(e){
      	e.preventDefault()

        
        if($(this).hasClass('up')){
          update_url_y_axis('up')
        }
      	else if($(this).hasClass('right')){
          update_url_x_axis('right')          
	    }
	    else if($(this).hasClass('down')){
          update_url_y_axis('down')
	    }
		else if($(this).hasClass('left')){
          update_url_x_axis('left')          
	    }
  	})
    
	
//     $('body').on('click', '#main-gallery .gallery-cell' ,function(e){
//     	e.preventDefault();        
//         var selectedIndex = $(this).parent().find('.is-selected').index()
//         console.log(selectedIndex)
        
//         //$(zoomSlider).select(4)
//         zoomSlider.flickity( 'select', selectedIndex )
        
// 		$('#product-zoom').addClass("active")
// 	})
	
//     $('#product-zoom').on('click', function(e){
    		
//       	e.preventDefault();
//       	var target = e.target
//         if($(target).hasClass('zoom-bg-close')){
//         	$('#product-zoom').removeClass('active')		
//         }
      	
//     })
    
    $('.clear-existing-logo').on('click', function(e){
      	e.preventDefault();
      	$('#custom_logo_url').val('')
        $('#custom_logo_file').val('')
        $('.logo-filename').text('')
        $('.existing-logo').removeClass('active')
        $('.logo-upload span').text('Upload Logo');
        $('.cloudinary-fileupload').show();
      	$('.logo-mover').remove()
        
        localStorage.removeItem('logo_id')
        localStorage.removeItem('logo_url')
        localStorage.removeItem('logo_original_filename')
        localStorage.removeItem('logo_scalable_image')
        localStorage.removeItem('logo_secure_url')
        
        resetAllProductImages()
                                
        $('.logo-upload-message').removeClass('active')
    });
  
    $('.logo-on-file button').on('click', function(e){
      $('.logo-on-file').addClass("selected");
      	e.preventDefault();
      	$('#custom_logo_url').html('<img src="'+window.logo_on_file+'" alt="Logo" width=50 height=50 />');
        $('#custom_logo_file').val('')
        $('.logo-filename').text('')
        $('.existing-logo').removeClass('active')
        $('.logo-upload span').text('Upload Logo');
        $('.cloudinary-fileupload').show();
      	$('.logo-mover').remove()
        
        localStorage.removeItem('logo_id')
        localStorage.removeItem('logo_url')
        localStorage.removeItem('logo_original_filename')
        localStorage.removeItem('logo_scalable_image')
        localStorage.removeItem('logo_secure_url')

        localStorage.setItem('logo_on_file', 'On File');
        $('.no-logo-panel').addClass('hide');
        
        resetAllProductImages()
                                
        $('.logo-upload-message').removeClass('active');
      $(".cart-item-order-logo").html('');
      $(".cart-logo-wrapper").html('<center>Logo On File</center>'+
'    <button type="button" class="cart-recap__note-button" data-action="toggle-collapsible" data-collapsible-force-overflow="" aria-controls="order-note" aria-expanded="true">Order Notes<span>'+
'            <span class="cart-recap__note-edit ">Edit</span><svg focusable="false" class="icon icon--arrow-bottom " viewBox="0 0 12 8" role="presentation">'+
'      <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>'+
'    </svg></span>'+
'    </button>'+
'    <div id="order-note" aria-hidden="false">'+
'        <div class="cart-recap__note-inner">'+
'            <textarea id="noteTextarea" name="note" class="form__field form__field--textarea" rows="3">'+mwProductFeesObjects?.cart?.note+'</textarea>'+
'            <button id="saveButton" type="button" class="form__submit form__submit--tight button button--secondary" data-action="save-note">Save</button>'+
'        </div>'+
'    </div>');

      fetch("/cart/update.js", {
        body: JSON.stringify({
          attributes: {
            'order_logo': 'logo_file'
          }
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(data => {
        if(window.location.href.includes("/cart")){
            window.location.reload();
        }
      });
      
    })
  if (getFromStorage('logo_on_file') == 'On File') {
    $('.logo-on-file').addClass("selected");
  }

  // Force show order note if it was previously hidden
  document.getElementById('order-note')?.classList.remove('hidden');
  document.getElementById('order-note')?.style.setProperty('display', 'block', 'important');
});

